import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
    return (
        <div className="min-h-screen bg-cream flex items-center justify-center px-6 relative overflow-hidden">
            {/* Background decorations */}
            <div className="absolute inset-0 bg-pattern" />
            <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-[#d4b86a]/10 rounded-full blur-3xl" />

            <div className="text-center relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <motion.h1
                        initial={{ scale: 0.5, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        className="text-9xl font-display font-bold gradient-text mb-4"
                    >
                        404
                    </motion.h1>

                    <h2 className="text-3xl md:text-4xl font-display text-gray-900 mb-3">
                        Page Not Found
                    </h2>

                    <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
                        The page you're looking for seems to have wandered off.
                        Let's get you back on track.
                    </p>

                    <div className="flex flex-wrap items-center justify-center gap-4">
                        <Link to="/">
                            <motion.button
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                                className="btn-primary inline-flex items-center space-x-2"
                            >
                                <Home className="w-4 h-4" />
                                <span>Go Home</span>
                            </motion.button>
                        </Link>

                        <motion.button
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={() => window.history.back()}
                            className="btn-outline inline-flex items-center space-x-2"
                        >
                            <ArrowLeft className="w-4 h-4" />
                            <span>Go Back</span>
                        </motion.button>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}
